// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__ZbpCr","socialLinks":"Contact_socialLinks__9VuUa","section":"Contact_section__TLIx5","twoColumn":"Contact_twoColumn__8NYZt"};